module.exports = __webpack_public_path__ + "img/uk.227a0d45.svg";